import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { FeatureFlagsLoadedAction } from './feature-flags.actions';
import { environment } from '../../../environments/environment';
import { SetUserId } from '../user/user.actions';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsEffects {
  initializeFeatureFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetUserId),
      map(() => FeatureFlagsLoadedAction({ flags: environment.featureFlags })),
    ),
  );

  constructor(private actions$: Actions) {}
}
